import { injectable } from 'inversify';
import Peer from './Peer';

@injectable()
class PeersStorage {
  private readonly peers = new Map<Peer['id'], Peer>();

  has(id: Peer['id']): boolean {
    return this.peers.has(id);
  }

  set(id: Peer['id'], peer: Peer): void {
    this.peers.set(id, peer);
  }

  get(id: Peer['id']): Peer | undefined {
    return this.peers.get(id);
  }

  delete(id: Peer['id']): boolean {
    return this.peers.delete(id);
  }

  all(): Peer[] {
    return Array.from(this.peers.values());
  }

  hosts(): Peer[] {
    return this
      .all()
      .filter((peer) => peer.role === 'host');
  }

  audience(): Peer[] {
    return this
      .all()
      .filter((peer) => peer.role === 'audience');
  }

  clear(): void {
    this.peers.clear();
  }
}

export default PeersStorage;
